<template>
  <div class="order-search-page">
    <div class="d-flex align-items-end justify-content-between">
      <h2>Order Search</h2>
      <!-- <router-link :to="{ name: 'CustomerOrder' }" class="btn btn-primary mb-2">New Order</router-link> -->
    </div>
    <hr>
    <div class="container-fluid pb-4">
      <div class="row">
        <div class="col">
          <BasicTextInput label='Product #' v-model="orderSearch.productNumber"/>
        </div>
        <div class="col">
          <BasicDropdown label='Order Status' :items="orderStatusOptions" v-model="orderSearch.orderStatus"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BasicTextInput label='Product Description' v-model="orderSearch.productDescription"/>
        </div>
        <div class="col">
          <BasicTextInput label='MFG'  v-model="orderSearch.manufacturer"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BasicTextInput label='Stock Code' v-model="orderSearch.stockCode"/>
        </div>
        <!-- <div class="col">
        <SalesRepSelect v-model="orderSearch.owner" class="mb-2" label="Order Owner" :salesReps="salesReps"/>
        </div> -->
        <div class="btn-wrapper col">
          <button type="button" @click="getFilteredOrders" class="btn btn-primary">
            <i class="fa fa-search" aria-hidden="true"></i> Search
          </button>
        </div>   
      </div>
    </div>
    <hr>
    <div class="subheader-wrapper">
      <h4>Orders</h4>
      <div class="icon-group">
        
        <router-link :to="{ name: 'CustomerOrder' }" class=""><i class="fa fa-plus" aria-hidden="true"></i></router-link>
        <button @click="goToMostRecentOrder" class="icon-btn">
            <i class="fa fa-forward" aria-hidden="true"></i>
          </button>
        <!-- <button class="icon-btn" @click="toggleCommitCheck(true)" :disabled="selectedRowsEmpty">
          <i class="fa fa-check-circle"  aria-hidden="true"></i>
        </button> -->
        <button class="icon-btn" :disabled="selectedRowsEmpty" @click="toggleDeleteCheck(true)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <!-- <i class="fa fa-file" aria-hidden="true"></i> -->
      </div>
      
    </div>
    
    <hr>
    <BasicDataGrid 
      :key="dataGridUpdateKey"
      :dataSource="dataSource" 
      gridRef="orderSearchGrid"
      :dataGridKey="dataGridKey"
      :columns="columns" 
      :actions="actions"
      :allowExport="false"
      :showColumnLines="true" 
      @selectedRowsChanged="selectedRowsChanged"
      @deleteOrder="deleteFromGrid" 
      @commit="commitFromGrid"
      @editOrder="editOrder"/>
      <Modal ref="deleteCheck">
        <div class="card modal-wrapper p-4">
          <p class="m-0">Are you sure you would like</p> 
          <p class="mt-0 ">to delete order(s)?</p>
          <div class="btn-wrapper center">
            <button class="btn btn-secondary" @click="toggleDeleteCheck">Cancel</button>
            <button @click="deleteConfirmed" class="btn btn-primary">Delete</button>
          </div>
        </div>
      </Modal>
      <Modal ref="commitCheck">
        <div class="card modal-wrapper p-4">
          <p class="m-0">Are you sure you would like</p> 
          <p class="mt-0 ">to commit order?</p>
          <div class="btn-wrapper center">
            <button class="btn btn-secondary" @click="toggleCommitCheck">Cancel</button>
            <button @click="commit" class="btn btn-primary">Commit</button>
          </div>
        </div>
      </Modal>
  </div>
</template>
<script>
import BasicDataGrid                                  from '../../../components/BasicDataGrid.vue';
import { OrderService, DealerService }                from '../../../services';

import {mapState}                                     from 'vuex'
import { stateEnum, getKeyByValue }    from "../../../modules/helpers.js";

// const dataSource = getDataSource('Orders')




export default {
  name: 'OrderSearch',
  components: {
    BasicDataGrid,
  },
  data() {
    return {
      dataGridKey: 'Id',
      dataGridUpdateKey: 1,
      dataSource: [],
      actions: [
        {
          key: 'delete', 
          hint: 'Delete',
          icon: 'trash',
          emit: 'deleteOrder',
        },
        {
          key: 'edit', 
          hint: 'Edit',
          icon: 'edit',
          emit: 'editOrder',
        },
        // {
        //   key: 'commit',
        //   hint: 'Commit',
        //   icon: 'check',
        //   emit: 'commit'
        // }
        ],
      multipleOrders: false,
      orderSearch: {
        productNumber: null,
        productDescription: null,
        stockCode: null,
        orderStatus: 4,
        manufacturer: null,
        owner: null
      },
      orderStatusOptions: [{text: 'All', value: 4}, {text: 'Uncommitted', value: 1}, {text: 'Committed', value: 2},{text: 'Submitted', value: 3}],
      selectedRows: [],
      // orders: [],
      columns: [
        {text: 'Order #', width: '150px', value: 'OrderNumber', dataType: "number"}, 
        {text: 'Order Date', width: '100px', value:'CreatedOn', dataType: "date"}, 
        {text: 'Order Owner', width: '175px', value:'SalesRepFullName', dataType: "string"}, 
        {text: 'Worksheet Name', width: '200px', value:'WorksheetName', dataType: "string"}, 
        {text: 'Customer #', width: '75px', value:'CustomerId', dataType: "number"}, 
        {text: 'Billing Name', width: '75px', value:'BillingInfo.Name', dataType: "string"}, 
        {text: 'Billing State', width: '75px', value:'BillingInfo.StateProvince', dataType: "string"}, 
        {text: 'Billing City', width: '75px', value:'BillingInfo.City', dataType: "string"}, 
        {text: 'Shipping Name', width: '75px', value:'ShippingInfo.Name', dataType: "string"}, 
        {text: 'Shipping State', width: '75px', value:'ShippingInfo.StateProvince', dataType: "string"}, 
        {text: 'Shipping City', width: '75px', value:'ShippingInfo.City', dataType: "string"},  
        {text: 'Installation Date', width: '75px', value:'InstalledOn', dataType: "date"}, 
        {text: 'Revision Date', width: '75px', value:'RevisedOn', dataType: "date"}, 
        {text: 'Expiration Date', width: '75px', value:'ExpiresOn', dataType: "date"}
      ],

      
      submittedId: 3,
      orderId: 0,
    };
  },
  methods: {
    goToMostRecentOrder(){
      OrderService.mostRecent()
        .then(res => {
          this.$router.push({ name: 'CustomerOrderEdit', params: { id: res.Id, cid: res.CustomerId } } );
        })
        .catch(err => {
          console.log(err)
        })
    },
    editOrder(e){

      let orderId = e.row.data.Id;
      let customerId = e.row.data.CustomerId;
      this.$router.push({ name: 'CustomerOrderEdit', params: { id: orderId, cid: customerId } } );
    },
    deleteFromGrid(e){
      this.toggleDeleteCheck(false)
      // this.order = e.row.data
      this.orderId = e.row.data.Id;
    },
    commitFromGrid(e){
      this.toggleCommitCheck(false)
      this.order = e.row.data
      this.orderId = [e.row.data.Id];
      // this.commitOrders(orderId)
      
    },
    commit(){
      this.multipleOrders ?
      this.commitMultipleRows() :
      this.commitOrders(this.orderId)
    },
    commitOrders(ids, message){
      let commitMessage = message || 'Order Committed'
      if(this.order.OrderStatusId === this.submittedId) {
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'This order has already been submitted' , type: 'error' });
        this.order = {};
        this.toggleCommitCheck()
        return;
      }
      else if(this.order.InstalledOn === null){
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Please add an Installation Date to the order before committing' , type: 'error' });
        this.order = {};
        this.toggleCommitCheck()
        return;
      }
      OrderService.commit(ids)
        .then(() => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: commitMessage , type: 'success' });
          this.selectedRows = [] 
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        this.toggleCommitCheck()
    },
    toggleCommitCheck(multiple){
      this.multipleOrders = multiple;
      this.$refs.commitCheck.toggle();
    },
    toggleDeleteCheck(multiple){
      this.multipleOrders = multiple;
      this.$refs.deleteCheck.toggle();
    },
    commitMultipleRows(){
      let committedRows = []
      let unableToCommit = []
      let ableToCommit = []
      this.selectedRows.forEach(row => {
        console.log('row', row)
        if(row.OrderStatusId === this.submittedId || row.InstalledOn === null){
          unableToCommit.push(row.Id)
        }else {
          committedRows.push(row.Id)
          ableToCommit.push(row.Id)
        }
        
      })
      if(unableToCommit.length > 0){
        let message = "Unable to commit orders: "
        unableToCommit.forEach((order, index)=> {
          if(index === 0) {
            message += order;
          } else {
            message += `, ${order}`
          }
        })
        message += "."
        this.$store.dispatch('ADD_NOTIFICATION', { text: message , type: 'error' });
      }
      let commitMessage ="Committed Orders: "
      if(ableToCommit.length > 0){
        ableToCommit.forEach((order, index)=> {
          if(index === 0) {
            commitMessage += order;
          } else {
            commitMessage += `, ${order}`
          }
        })
        commitMessage += "."
      } 
      if(committedRows.length <= 0) return;
      this.commitOrders(committedRows, commitMessage)
    },
    deleteConfirmed(){
      this.multipleOrders ?
      this.deleteMultipleRows() :
      this.deleteOrder(this.orderId)
    },
    deleteMultipleRows(){
      let deletedRows = []
      this.selectedRows.forEach(row => {
        deletedRows.push(row.Id)
      })
      deletedRows.sort(function(a,b){ return b - a; })
      OrderService.deleteMultiple(deletedRows)
        .then(() => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Selected Orders have been deleted" , type: 'success' });
          // for (var i = deletedRows.length -1; i >= 0; i--){
          //   let index = this.orders.map(order => order.Id).indexOf(deletedRows[i])
            
          //   this.orders.splice(index,1);
          // }
          this.dataGridUpdateKey++;
          this.selectedRows = [] 
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        .finally(() => {
          this.toggleDeleteCheck();
        })
    },
    
    deleteOrder(){
      OrderService.delete({id: this.orderId})
        .then((res) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been deleted" , type: 'success' });
          this.dataGridUpdateKey++;
          // this.orders.splice([event.row.rowIndex],1)
        })
        .catch((err) => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
        })
        .finally(()=> {
          this.toggleDeleteCheck();
        })
  
    },
    selectedRowsChanged(rows){
      this.selectedRows = rows;
    }, 
    getFilteredOrders(){
        let data = {
          PartNumber: this.orderSearch.productNumber,
          PartDescription: this.orderSearch.productDescription,
          StockCode: this.orderSearch.stockCode,
          OrderStatusId: this.orderSearch.orderStatus,
          Manufacturer: this.orderSearch.manufacturer,
          OrderOwner: this.orderSearch.owner
        };
        // this.dataSource = getDataSource('Orders/Search', data)
        OrderService.filtered(data).then(res => {
          this.dataSource = res
        }).catch(err => {
          console.error(err);
        })    
    },
    getOrders(){
        this.dataSource = OrderService.getDataSource(this.dataGridKey)
    }
  },
  computed: {
    ...mapState(['currentUser', 'usStates']),
    selectedRowsEmpty(){
      return this.selectedRows.length <= 0
    }
  },
  created(){
    this.getOrders()
  }
  
};

</script>
<style lang="scss" scoped>
  .order-search-page {
    // max-width: 1800px;
  }
  .icon-btn{
    border: none;
    background-color: transparent;
    padding: 0px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    &.center{
      justify-content: space-around;
      align-items: center;
    }
    
    .btn {
      margin: 5px;
    }
  }
  .modal-wrapper{
    width: 300px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>
